/**
 * Normalize feed/API team codes to blob filenames under picks-core/mlb/.
 * Mirrors apps/daily-reveal and admin jersey-mapping.
 */
export const MLB_BLOB_TEAM_CODE_MAP: Record<string, string> = {
  AZ: 'ARI',
  DIA: 'ARI',
  ANA: 'LAA',
};

export function normalizeMlbBlobTeamCode(teamCode: string | null | undefined): string {
  if (!teamCode || typeof teamCode !== 'string') return '';
  const code = teamCode.trim().toUpperCase().slice(0, 3);
  return MLB_BLOB_TEAM_CODE_MAP[code] ?? code;
}
